// Discriminator sent on the polymorphic Booking payload to mark a staff booking. The generated
// client types it as a plain `string`, so it is not inferred — we set it explicitly when building
// a request. Shared occurrence/recurrence constants live in `../Bookings/shared`.
export const STAFF_BOOKING_TYPE = 'STAFF' as const;
